'use client'

/**
 * Prefixos das chaves de `localStorage` que guardam estado derivado do servidor:
 * o cache do react-query persistido (`pgee-cache-<userId>-v<app>-g<gamification>`)
 * e o estado espelhado em `pgee.data` / `pgee.currents` / `pgee.activeJourney`.
 *
 * Nenhuma delas é fonte da verdade — tudo é rebuscado no próximo carregamento.
 * A sessão vive em cookie e não é tocada aqui, então limpar o cache não desloga
 * o aluno.
 */
const PURGEABLE_PREFIXES = ['pgee-cache-', 'pgee.']

/**
 * Descarta o estado cacheado localmente.
 *
 * Existe porque o cache persistido tem `maxAge` de 24h e é lido antes de
 * qualquer refetch (`refetchOnMount: false`): um payload que quebra a
 * renderização volta igual a cada reload, e o aluno fica preso na tela de erro
 * até o cache expirar. Sem isto, recarregar a página não é saída.
 *
 * Livre de contexto de propósito — roda a partir da tela de erro da raiz, que
 * renderiza fora dos providers.
 */
export function purgeLocalCache(): void {
  if (typeof window === 'undefined') return

  for (const key of Object.keys(window.localStorage)) {
    if (PURGEABLE_PREFIXES.some(prefix => key.startsWith(prefix))) {
      window.localStorage.removeItem(key)
    }
  }
}
